import React from 'react'
import PropTypes from 'prop-types'
import Panel from './Panel'
import { Select, makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    pointerEvents: 'all',
    fontSize: '1.5rem',
    fontStyle: props =>
      props.italic ? 'italic' : 'normal',
    display: 'flex',
    margin: -1 * theme.spacing(2),
    marginBottom: -1 * theme.spacing(2) - 1,
    '&:before': {
      borderRadius: theme.shape.borderRadius,
      borderBottomColor: theme.palette.primary.light
    },
    '&:after': {
      display: 'none'
    }
  },
  selectRoot: {
    padding: theme.spacing(2),
    lineHeight: 1
  },
  selectIcon: {
    right: theme.spacing(2),
    width: 40,
    height: 40,
    top: 40 / 2 - 10
  },
  panelRoot: {
    maxWidth: 460
  }
}))

const SelectPanel = ({
  title,
  children,
  italic,
  PanelProps,
  ...props
}) => {
  const classes = useStyles({ italic })
  return (
    <Panel
      title={title}
      variant="outlined"
      className={classes.panelRoot}
      {...PanelProps}>
      <Select
        className={classes.root}
        classes={{
          root: classes.selectRoot,
          icon: classes.selectIcon
        }}
        {...props}>
        {children}
      </Select>
    </Panel>
  )
}

SelectPanel.propTypes = {
  title: PropTypes.string,
  PanelProps: PropTypes.object
}

export default SelectPanel
